<template>
  <v-container fluid>
    <v-app-bar app light fixed>
      <v-app-bar-title>
        <v-layout align-center>
          <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="$vuetify.breakpoint.smAndDown">
          </v-toolbar-side-icon>
          <img
            src="@/assets/mrclogo.svg"
            alt="Management Resources Consultants"
            style="max-width:80px"
            class="mx-1"
          />
          Executive Compensation User Admin
        </v-layout>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="logout">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <v-card>
        <v-card-title class="py-1">
          <h6 class="title">Users Countries Subscription</h6>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            class="pt-1 mt-0"
            hide-details
          >
          </v-text-field>
        </v-card-title>
        <v-data-table
          :items-per-page-options="[10, 15, 20]"
          :headers="headers"
          :items="users"
          :search="search"
        >
          <template v-slot:item="props">
            <tr>
              <td class="text-xs-left uneditable">{{ props.item.userID }}</td>
              <td class="text-xs-left uneditable">{{ props.item.userName }}</td>
              <td class="text-xs-left uneditable">{{ props.item.company }}</td>
              <td
                class="text-xs-left"
              >
                <v-autocomplete
                  multiple
                  :items="countries"
                  item-text="countryName"
                  :value="props.item.countriesSubscribed"
                  solo
                  autofocus
                  item-value="countryCode"
                  @change="countriesInput($event, props.item)"
                  hide-details
                  single-line
                >
                </v-autocomplete>
                <!-- {{ props.item.countriesSubscribed.join(', ') }} -->
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
        <!-- <SelectEditDialog
          :visible.sync="visible"
          :items="countries"
          itemText="countryName"
          itemValue="countryCode"
          :left="left"
          :top="top"
          :value="itemOnSelect"
          v-click-outside="hideSelectEditDialog"
          @input="countriesInput"
        >
        </SelectEditDialog> -->
      </v-card>
      <v-snackbar v-model="snackbarVisible" :timeout="1500" right>
        {{ msg }}
        <v-btn color="pink" text @click="snackbarVisible = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-main>
  </v-container>
</template>
<script>
import ClickOutside from 'vue-click-outside';
import { mapActions } from 'vuex';
// import SelectEditDialog from '../components/SelectEditDialog.vue';
import countries from '../countries';

export default {
  methods: {
    countriesInput(e, item) {
      const userToSave = {
        ...item,
        countriesSubscribed: e,
      };
      const i = this.users.findIndex((u) => u.userID === userToSave.userID);
      const oldUser = JSON.parse(JSON.stringify(this.users[i]));
      this.mutateExecCompUser(userToSave)
        .then((data) => {
          if (data) {
            this.msg = 'Changes saved';
            this.snackbarVisible = true;

            if (i >= 0) {
              this.$set(this.users, i, userToSave);
            }
          } else {
            this.msg = 'Fail to save';
            this.snackbarVisible = true;
            if (i >= 0) {
              this.$set(this.users, i, userToSave);
              this.$nextTick(() => {
                this.$set(this.users, i, oldUser);
              });
            }
          }
        })
        .catch(() => {
          this.msg = 'Fail to save';
          this.snackbarVisible = true;
          if (i >= 0) {
            this.$set(this.users, i, userToSave);
            this.$nextTick(() => {
              this.$set(this.users, i, oldUser);
            });
          }
        });
    },
    setAccess(e, user, prop) {
      const userToSave = {
        ...user,
        [prop]: e,
      };
      const i = this.users.findIndex((u) => u.userID === userToSave.userID);
      const oldUser = JSON.parse(JSON.stringify(this.users[i]));
      this.mutateExecCompUser(userToSave)
        .then((data) => {
          if (data) {
            this.msg = 'Changes saved';
            this.snackbarVisible = true;

            if (i >= 0) {
              this.$set(this.users, i, userToSave);
            }
          } else {
            this.msg = 'Fail to save';
            this.snackbarVisible = true;
            if (i >= 0) {
              this.$set(this.users, i, userToSave);
              this.$nextTick(() => {
                this.$set(this.users, i, oldUser);
              });
            }
          }
        })
        .catch(() => {
          this.msg = 'Fail to save';
          this.snackbarVisible = true;
          if (i >= 0) {
            this.$set(this.users, i, userToSave);
            this.$nextTick(() => {
              this.$set(this.users, i, oldUser);
            });
          }
        });
    },
    // hideSelectEditDialog() {
    //   if (this.visible) {
    //     this.visible = false;
    //     this.$nextTick(() => {
    //       this.itemOnEdit = {};
    //       this.propOnEdit = '';
    //       this.itemOnSelect = [];
    //     });
    //   }
    // },
    // showSelectDialog(e, { selection, item, prop }) {
    //   const target = e.currentTarget;
    //   setTimeout(() => {
    //     this.left = `${target.offsetLeft + 20}px`;
    //     this.top = `${target.offsetTop + 46}px`;
    //     this.visible = true;
    //     this.itemOnEdit = item;
    //     this.propOnEdit = prop;
    //     this.itemOnSelect = selection;
    //   }, 0);
    // },
    logout() {
      fetch('/sign/out', {
        credentials: 'include',
      }).then(() => {
        window.location.href = '/sign/in?source=/exec-comp';
      });
    },
    ...mapActions(['queryExecCompUsers', 'mutateExecCompUser']),
  },
  created() {
    this.queryExecCompUsers().then((data) => {
      this.users = data;
    });
  },
  computed: {},
  data() {
    return {
      snackbarVisible: false,
      msg: '',
      countries,
      // itemOnEdit: {},
      // propOnEdit: '',
      scrollLeft: 0,
      // left: '0px',
      // top: '0px',
      // visible: false,
      // itemOnSelect: [],
      search: '',
      headers: [
        { text: 'User ID', align: 'left', value: 'userID' },
        { text: 'User Name', value: 'userName', align: 'left' },
        { text: 'Company', value: 'company', align: 'left' },
        // {
        //   text: 'Public', value: 'accessPublic', align: 'left', sortable: false,
        // },
        // {
        //   text: 'Private', value: 'accessPrivate', align: 'left', sortable: false,
        // },
        {
          text: 'Countries subscribed',
          value: 'countriesSubscribed',
          align: 'left',
          sortable: false,
        },
      ],
      users: [
        {
          userID: '',
          userName: '',
          company: '',
          countriesSubscribed: [],
          accessPublic: false,
          accessPrivate: false,
        },
      ],
    };
  },
  mounted() {},
  components: {
    // SelectEditDialog,
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style scoped>
.uneditable {
  background-color: #eceff1;
  width: 280px;
}
</style>
